export default "__VITE_ASSET__DvKvxCaN__"